
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.428 19.237a.7.7 0 00.925.857l16.992-6.689a.7.7 0 000-1.303L3.353 5.414a.7.7 0 00-.925.857l1.657 5.382a.7.7 0 00.63.493l10.79.607-10.79.608a.7.7 0 00-.63.493l-1.657 5.383z","fill":"#348EF6"}})])
          )
        }
      }
    